import { ProductMaskOptionsApiRemoteService } from '../../Services/api/product-mask-options/product-mask-options-service'
import { IListProductMaskOptionsPayload, TProductMaskOptionsApiResponse } from '../../Services/api/product-mask-options/product-mask-options.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'

export class ListProductMaskOptionsUseCase
implements IFormUsecase<IListProductMaskOptionsPayload, TProductMaskOptionsApiResponse> {
  constructor(private readonly ProductMaskOptionsApi: ProductMaskOptionsApiRemoteService) {}

  public async handle(data: IListProductMaskOptionsPayload = {}): Promise<Result<TProductMaskOptionsApiResponse>> {
    try {
      return await this.ProductMaskOptionsApi.list(data)
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
